interface Upgrades {
  hull: number;
  cap: number;
  kinetic: number;
  magnet: number;
  phoenix: number;
}

const SHARD_KEY = 'ns_shards_pixi';
const UPG_KEY = 'ns_upgrades_pixi';

const DEFAULTS: Upgrades = { hull: 0, cap: 0, kinetic: 0, magnet: 0, phoenix: 0 };

export const HULL_BONUS = [0, 5, 10, 20];
export const CAP_BONUS = [0, 2, 5, 10];
export const KINETIC_MUL = [1, 1.05, 1.10, 1.15];
export const MAGNET_MUL = [1, 1.5, 2.0];
export const PHOENIX_LVL = [0, 1];

export const COSTS = {
  hull: [10, 40, 120],
  cap: [10, 40, 120],
  kinetic: [15, 50, 150],
  magnet: [20, 80],
  phoenix: [200],
};

export function getShards(): number {
  return parseInt(localStorage.getItem(SHARD_KEY) || '0', 10) || 0;
}
export function setShards(n: number): void {
  localStorage.setItem(SHARD_KEY, Math.max(0, Math.floor(n)).toString());
}
export function addShards(delta: number): void {
  setShards(getShards() + delta);
}
export function getUpgrades(): Upgrades {
  try {
    const raw = JSON.parse(localStorage.getItem(UPG_KEY) || '{}');
    return { ...DEFAULTS, ...raw };
  } catch { return { ...DEFAULTS }; }
}
export function saveUpgrades(u: Upgrades): void {
  localStorage.setItem(UPG_KEY, JSON.stringify(u));
}

export function buyUpgrade(kind: keyof Upgrades): boolean {
  const u = getUpgrades();
  const costs = COSTS[kind];
  if (u[kind] >= costs.length) return false;
  const cost = costs[u[kind]];
  const shards = getShards();
  if (shards < cost) return false;
  setShards(shards - cost);
  u[kind] += 1;
  saveUpgrades(u);
  return true;
}

export function resetProgression(): void {
  localStorage.removeItem(SHARD_KEY);
  localStorage.removeItem(UPG_KEY);
}

export function calcShardsEarned(score: number, bossKills: number, wavesCleared: number): number {
  return Math.floor(score / 1000) + bossKills * 5 + wavesCleared;
}

export function applyUpgradesToPlayer(p: { hp: number; maxHp: number; shield: number; maxShield: number }): void {
  const u = getUpgrades();
  p.maxHp += HULL_BONUS[u.hull] || 0;
  p.hp = p.maxHp;
  p.maxShield += CAP_BONUS[u.cap] || 0;
  p.shield = p.maxShield;
}

export function dmgMultFromUpgrades(): number {
  return KINETIC_MUL[getUpgrades().kinetic] || 1;
}
export function magnetRadiusMult(): number {
  return MAGNET_MUL[getUpgrades().magnet] || 1;
}
export function phoenixLevel(): number {
  return PHOENIX_LVL[getUpgrades().phoenix] || 0;
}
